"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensesService = void 0;
class LicensesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Licenses({ authorization = 'Bearer <token>', }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/licenses',
            headers: {
                Authorization: authorization,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1WorkspacesLicenses({ workspaceId, authorization = 'Bearer <token>', }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/workspaces/{workspaceId}/licenses',
            path: {
                workspaceId: workspaceId,
            },
            headers: {
                Authorization: authorization,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1WorkspacesLicenses1({ authorization = 'Bearer <token>', }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/workspaces/licenses',
            headers: {
                Authorization: authorization,
            },
        });
    }
}
exports.LicensesService = LicensesService;
